import {i18n} from "ui/i18n";
import Alert from "ui/dialogs/alert/Alert";

export default class UnsupportedBrowserDetector {
	async checkAndAlert() {
		if (screen.width < 1200) {
			await this._showAlert(i18n('errors.client.screen-width'));
			return false;
		}

		if (!('indexedDB' in window)) {
			await this._showAlert(i18n('errors.client.indexed-db'));
			return false;
		}

		if (!('showSaveFilePicker' in window)) {
			await this._showAlert(i18n('errors.client.file-access-api'));
			return false;
		}
		return true;
	}

	async _showAlert(msg) {
		await new Alert(msg, 'error').getResult();
	}
}
